export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-clipboard-pencil-0f87dc154cfc204bb6d62bbc67ce43d4.svg";